<template>
  <v-dialog max-width="800" max-height="800" v-model="dialog" persistent>
    <v-card>
      <v-card-text>
        <div
          v-if="viewStatus === 1"
          class="d-flex justify-content-center align-items-center"
        >
          <iframe
            id="frame"
            style="height: 800px; width: 800px"
            :srcdoc="paymentHtml"
            @load="loadActionReady"
          ></iframe>
        </div>
        <div
          v-else-if="viewStatus === 2"
          class="d-flex justify-content-center align-items-center"
        >
          <div
            style="height: 800px; width: 800px"
            class="col-lg-12 d-flex justify-content-center align-items-center flex-column"
          >
            <i
              class="mb-10 mdi mdi-check-decagram"
              style="color: darkgreen; font-size: 120px"
            ></i>
            <p class="mt-10 fs-1 font-weight-bold">Ödemeniz başarıyla alınmıştır.</p>
            <p class="fs-2">Yönlendiriliyorsunuz...</p>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Yükleniyor...</span>
            </div>
          </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center">
          <div
            style="height: 800px; width: 800px"
            class="col-lg-12 d-flex justify-content-center align-items-center flex-column"
          >
            <i
              class="mb-10 mdi mdi-alert-decagram"
              style="color: crimson; font-size: 120px"
            ></i>
            <p class="mt-10 fs-1 font-weight-bold">
              Ödemeniz sırasında hata oluşmuştur.
            </p>
            <p class="fs-2">Yönlendiriliyorsunuz...</p>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Yükleniyor...</span>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConfirmPaymentDialog",
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    paymentHtml: {
      type: String,
      default: null,
    },
    confirmLoading: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      dialog: false,
      viewStatus: 1,
    };
  },
  methods: {
    loadActionReady() {
      this.$emit("iframeLoaded");
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    confirmLoading: function (newVal) {
      this.viewStatus = newVal;
      if (newVal === 2) {
        setTimeout(() => {
          this.dialog = false;
          this.$router.push({ name: "payment" });
        }, 3000);
      }
      if (newVal === 3) {
        setTimeout(() => {
          this.dialog = false;
          this.$router.push({ name: "virtualPayment" });
          window.location.reload();
        }, 3000);
      }
    },
  },
});
</script>
<style scoped></style>
